import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const BathukammaCelebrations2025 = () => {
    const workshopImages = [
        "1.jpg ",
        "2.jpg ",
        "3.jpg ",
    ];
    
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        A Day of Tradition and Joy: Bathukamma and Dassera Celebrated
                                    </h2>
                                    <div className='py-2'>
                                        <p>
                                            The college grounds were filled with festive energy on Saturday, September 28th, as we hosted a full day of celebrations! The day began with a puja performed by all the departments in their respective labs and the HoD's room. The highlight was the collective creation of magnificent, floral Bathukamma—a true team effort between faculty and students—which then became the center of enthusiastic dancing to traditional songs. It was a beautiful display of culture and community.

                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">

                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Bathukamma-celebrations-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Bathukamma-celebrations-2025/${img}`}
                                                            alt={`Bathukamma celebrations 2025 Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default BathukammaCelebrations2025;
